import { useState, useEffect, useRef } from 'react';

// --- CONSTANTS FOR GUIDE FLOW ---
const GUIDE_FLOWS = {
    expense: [
        { id: 'btn-add-expense', type: ['click'], msg: "Add Expense बटन पर क्लिक करें।" },
        { id: 'input-exp-date', type: ['change'], msg: " तारीख चुनें।" },
        { id: 'select-exp-cat', type: ['change'], msg: " लिस्ट में से Expense यानी खर्चे का प्रकार चुनें।" },
        { id: 'input-exp-amount', type: ['keydown'], msg: " Expense यानी खर्चे की रकम भरें, और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-exp-party', type: ['keydown'], msg: " जिसको पैसे दिए हैं उसका नाम लिखें, और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'select-exp-status', type: ['change'], msg: " आपने ये Expense यानी खर्चा चुका दिया है या बाकी है? Paid या Pending चुनें।" },
        { id: 'btn-save-expense', type: ['click'], msg: " बहुत बढ़िया! अब 'Save Expense' बटन दबा कर इसे हमेशा के लिए सेव करें।" }
    ],

    yarn_purchase: [
        { id: 'btn-add-expense', type: ['click'], msg: " Yarn खरीदने यानी धागा खरीदने की एंट्री करने के लिए सबसे पहले Add Expense बटन पर क्लिक करें।" },
        { id: 'tab-yarn-expense', type: ['click'], msg: " अब ऊपर दिए गए Yarn Purchase Button पर क्लिक करें।" },
        { id: 'input-yarn-date', type: ['change'], msg: " Yarn खरीदने यानी धागा खरीदने की तारीख चुनें, और Next Step बटन पर क्लिक करें।" },
        { id: 'select-yarn-material', type: ['change'], msg: " Yarn मटेरियल यानी धागे का मटेरियल चुनें (जैसे: Cotton, poplin, cambric, Polyester, या कोई और), और Next Step बटन पर क्लिक करें।" },
        { id: 'select-yarn-type', type: ['change'], msg: " Yarn Type चुनें यानी धागे का प्रकार चुनें, और Next Step बटन पर क्लिक करें।" },
        { id: 'input-yarn-qty', type: ['keydown'], msg: " कितना किलो Yarn ख़रीदा यानी कितना किलो धागा ख़रीदा, वो यहाँ लिखें, और Next Step बटन पर क्लिक करें।" },
        { id: 'input-yarn-price', type: ['keydown'], msg: " 1 किलो yarn यानी 1 किलो धागा आपने कितने रुपये में खरीदा है, वो रेट यहाँ लिखें और Next Step बटन पर क्लिक करें।" },
        { id: 'btn-save-yarn', type: ['click'], msg: " बहुत बढ़िया! अब Save Stock बटन दबाकर इसे सेव करें।" }
    ],

    revenue: [
        { id: 'btn-add-revenue', type: ['click'], msg: " Add Revenue बटन पर क्लिक करें।" },
        { id: 'input-rev-date', type: ['change'], msg: " Fabric बेचने की यानी कपड़ा बेचने की तारीख चुनें।" },
        { id: 'select-rev-fabric', type: ['change'], msg: " Fabric Type यानी कपड़े का प्रकार चुनें।" },
        { id: 'select-rev-material', type: ['change'], msg: " अब Fabric Material यानी कपड़े का मटेरियल चुनें।" },
        { id: 'input-rev-rate', type: ['keydown'], msg: " Fabric का रेट यानी 1 मीटर कपड़ा बेचने पर आपको कितने रुपये मिल रहे हैं, वो रेट यहाँ लिखें, और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-rev-qty', type: ['keydown'], msg: " कितना मीटर Fabric बेचा यानी कितना मीटर कपड़ा बेचा वो लिखें , और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-rev-party', type: ['keydown'], msg: " जिसको Fabric बेचा यानी जिसको कपड़ा बेचा उस पार्टी का नाम या उनकी Firm/Company का नाम यहाँ लिखें, और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'select-rev-status', type: ['change'], msg: " आपको इसके पैसे मिल गए हैं या उधार है? पैसे मिल गए हैं तो पेड चुनें, या अगर पैसे नहीं मिले  हैं तो पेंडिंग चुनें।" },
        { id: 'btn-save-revenue', type: ['click'], msg: " शाबाश! अब Save Revenue बटन दबा कर इसे सेव करें।" }
    ],
    report: [
        { id: 'btn-download-pdf', type: ['click'], msg: " अपने Textile कारखाने की Financial Report (Profit & Loss) PDF रिपोर्ट निकालने के लिए यहाँ PDF बटन पर क्लिक करें।" },
        { id: 'input-report-from', type: ['change'], msg: " आपको रिपोर्ट किस तारीख से शुरू करनी है (From Date), वो चुनें, और Next Step बटन पर क्लिक करें।" },
        { id: 'input-report-to', type: ['change'], msg: " रिपोर्ट किस तारीख तक की चाहिए (To Date), वो चुनें, और Next Step बटन पर क्लिक करें।" },
        { id: 'btn-save-pdf', type: ['click'], msg: " बहुत बढ़िया! अब Download PDF बटन दबाकर पीडीएफ रिपोर्ट फाइल को अपने फोन में सेव करें।" }
    ],
    ledger: [  
        { id: 'tab-ledger', type: ['click'], msg: " किसको कितने रुपये देने बाकी है और किससे कितने रुपये लेने बाकी है चेक करने के लिए Party Ledger Button पर क्लिक करें।" },
        { id: 'ledger-receivables', type: [], msg: " यह Amount to Receive यानी रुपये लेने बाकी हैं, का Box है। यहाँ वो लिस्ट है जिनसे आपको रुपये लेने बाकी हैं। अच्छे से देख लें और फिर Next Step बटन पर क्लिक करें।" },
        { id: 'ledger-payables', type: [], msg: " और यह Amount to Pay यानी रुपये देने बाकी हैं, का Box है। यहाँ वो लिस्ट है जिनको आपको रुपये चुकाने हैं। आपका ट्यूटोरियल पूरा हुआ, अब End Live Guide पर क्लिक करके गाइड बंद कर सकते हैं।" }
    ],
    
    // --- ADVANCE PAYMENT GUIDE FLOW ---
    advance_payment: [
        { id: 'tab-new', type: ['click'], msg: " Worker को Advance रुपये देने के लिए सबसे पहले Transaction Button पर क्लिक करें।" },
        { id: 'select-worker', type: ['change'], msg: " लिस्ट में से उस Worker को चुनें जिसे आप Advance रुपये देना चाहते हैं।" },
        { id: 'btn-give-adv', type: ['click'], msg: " अब यहाँ Give Advance बटन पर क्लिक करें।" },
        { id: 'input-amount', type: ['keydown'], msg: " Worker को कितना Advance रुपये देना है, वो रकम यहाँ भरें और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-date', type: ['change'], msg: " Advance रुपये देने की तारीख चुनें।" },
        { id: 'mode-selection-box', type: ['change'], msg: " इसके बाद Payment मोड चुनें Cash या Online, अगर Online चुनते हैं तो जिस ऐप से आप Advance रुपये दे रहे हैं उस ऐप को चुनें, इसके बाद Next Step बटन दबाएं।" },
        { id: 'online-apps-box', type: ['click'], msg: " आपने ऑनलाइन चुना है, तो लिस्ट में से Payment ऐप Select करें PhonePe, GPay, Paytm, BharatPe या Other, चुनें और Next Step बटन पर क्लिक करें।" },
        { id: 'btn-save-payment', type: ['click'], msg: " बहुत बढ़िया! आखिर में Pay Advance बटन पर क्लिक करें,  Worker को Advance Pay हो जाएगा!" }
    ],

   // --- PAYMENT GUIDE FLOWS ---
    salary_payment: [
        // 👇 यह पहला स्टेप ऐड किया गया है 👇
        { id: 'tab-new', type: ['click'], msg: " Worker को Salary देने के लिए सबसे पहले Transaction Button पर क्लिक करें।" }, 
        
        { id: 'select-worker', type: ['change'], msg: () => {
            // 👇 जादू: अमाउंट इनपुट के लाल रंग से चेक करेगा कि 'Advance' बटन दबा है या नहीं
            const amtInput = document.getElementById('input-amount');
            const isAdvance = amtInput && (amtInput.style.color === 'rgb(211, 47, 47)' || amtInput.style.color.includes('d32f2f') || amtInput.style.color.includes('D32F2F'));
            if (isAdvance) {
                return " जिस वर्कर को एडवांस देना है, सबसे पहले उस वर्कर को यहाँ से सेलेक्ट करें।";
            }
            return " जिस वर्कर को Salary देना है, सबसे पहले उस वर्कर को यहाँ से सेलेक्ट करें।";
        }},
        { id: 'salary-period-box', type: ['click'], msg: " अगर आपको वर्कर को हफ़्ते की सैलरी देना है तो, Current Week चुनें, और अगर वर्कर को महीने की सैलरी देना है तो, Current Month पर क्लिक करें और Next Step बटन दबाएँ।" },
        { id: 'input-prod-meters', type: ['keydown'], msg: () => {
            // 👇 जादू: यह चेक करेगा कि 'Current Month' का बटन एक्टिव (Select) है या नहीं
            let isMonth = false;
            const periodBox = document.getElementById('salary-period-box');
            if (periodBox) {
                const buttons = periodBox.getElementsByTagName('button');
                for (let btn of buttons) {
                    if (btn.innerText.includes('Month') && !btn.style.background.includes('transparent')) {
                        isMonth = true;
                    }
                }
            }
            
            if (isMonth) {
                return " इस महीने जितना मीटर प्रोडक्शन हुआ है वह ऑटोमैटिक आ जाएगा, अगर नहीं आया है तो यहाँ पर लिखें कितना मीटर प्रोडक्शन किया है, और Next Step बटन पर क्लिक करके आगे बढ़ें।";
            } else {
                return " इस हफ्ते जितना मीटर प्रोडक्शन हुआ है वह ऑटोमैटिक आ जाएगा, अगर नहीं आया है तो यहाँ पर लिखें कितना मीटर प्रोडक्शन किया है, और Next Step बटन पर क्लिक करके आगे बढ़ें।";
            }
        }},
        { id: 'input-rate', type: ['keydown'], msg: " उसके बाद एक मीटर कपड़ा प्रोडक्शन करने पर कितने रुपये देना चाहते हो चेक करें, ज़रूरत हो तो बदलें और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-recovery', type: ['keydown'], msg: " अगर आप वर्कर की सैलरी से दिए गए एडवांस के पैसे काटना चाहते हैं, तो यहाँ पर अमाउंट दर्ज करें कितने पैसे काटने हैं।" },
        { id: 'input-amount', type: ['keydown'], msg: () => {
            const amtInput = document.getElementById('input-amount');
            const isAdvance = amtInput && (amtInput.style.color === 'rgb(211, 47, 47)' || amtInput.style.color.includes('d32f2f') || amtInput.style.color.includes('D32F2F'));
            if (isAdvance) {
                return " एडवांस की रकम भरें, और Next Step बटन पर क्लिक करके आगे बढ़ें।";
            }
            return " अमाउंट आटोमेटिक कैलकुलेट हो जाएगी, अगर आपको लगता है अमाउंट सही नहीं है तो चेंज करें और Next Step बटन पर क्लिक करके आगे बढ़ें।";
        }},
        { id: 'input-date', type: ['change'], msg: " उसके बाद तारीख चेक करें सही है या नहीं।" },
        { id: 'mode-selection-box', type: ['change'], msg: " इसके बाद पेमेंट मोड चुनें (कैश या Online), अगर Online चुनते हैं तो जिस ऐप से आप वर्कर को सैलरी दे रहे हैं उस ऐप को चुनें, जैसे: PhonePe, Paytm वगैरह पर क्लिक करें। इसके बाद Next Step बटन दबाएं।" },
        { id: 'online-apps-box', type: ['click'], msg: " आपने ऑनलाइन चुना है, तो लिस्ट में से Payment ऐप Select करें PhonePe, GPay, Paytm, BharatPe या Other, चुनें और Next Step बटन पर क्लिक करें।" },
        { id: 'btn-save-payment', type: ['click'], msg: " आखिर में Pay Salary बटन पर क्लिक करें, Worker को Salary Pay हो जाएगा!" }
    ],

    // --- PAYMENT REPORT GUIDE FLOW ---
    payment_report: [
        { id: 'tab-history', type: ['click'], msg: " Workers को दी गई पिछली Salary और Advance की डिटेल्स देखने के लिए सबसे पहले History & Reports Button पर क्लिक करें।" },
        { id: 'btn-download-report', type: ['click'], msg: " Salary और Advance पेमेंट्स रिकॉर्ड की रिपोर्ट पीडीएफ फाइल डाउनलोड करने के लिए 'Report' बटन पर क्लिक करें।" },
        { id: 'select-report-worker', type: ['change'], msg: " जिस वर्कर की Salary और Advance पेमेंट्स रिकॉर्ड की रिपोर्ट चाहिए, लिस्ट में से उसका नाम चुनें, अगर सभी वर्कर्स की रिपोर्ट चाहिए तो All Workers ही रहने दें, और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-report-from', type: ['change'], msg: " आपको रिपोर्ट किस तारीख की चाहिए (From Date), वो Date चुनें, और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-report-to', type: ['change'], msg: " आपको रिपोर्ट किस तारीख तक की चाहिए (To Date), वो Date चुनें, और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'btn-save-pdf', type: ['click'], msg: " बहुत बढ़िया! अब Download PDF बटन दबाकर Salary और Advance पेमेंट्स रिकॉर्ड की रिपोर्ट पीडीएफ फाइल को अपने फोन में सेव करें।" }
    ],

    // --- SHARE RECEIPT GUIDE FLOW ---
    share_receipt: [
        { id: 'tab-history', type: ['click'], msg: " Salary Receipt Share करने के लिए सबसे पहले History & Reports Button पर क्लिक करें।" },
        { id: 'history-item-0', type: ['click'], msg: " Transaction लिस्ट में से जिस Worker की सैलरी Receipt शेयर करनी है उस पर क्लिक करें ताकि उसकी पूरी डिटेल्स खुल सकें।" },
        { id: 'btn-share-receipt', type: ['click'], msg: " बहुत अच्छे! अब Salary Receipt शेयर करने के लिए Share Receipt बटन दबाएं, यह सीधा WhatsApp में खुलेगा, WhatsApp में जिसको शेयर करना है शेयर कर सकते हो।" }
    ],
    
    // --- EDIT PAYMENT GUIDE FLOW ---
    edit_payment: [
        { id: 'tab-history', type: ['click'], msg: " Salary Receipt में बदलाव करने के लिए History & Reports Button पर क्लिक करें, और Next Step बटन पर क्लिक करें।" },
        { id: 'history-item-0', type: ['click'], msg: " Transaction लिस्ट में से जिस Salary Receipt में बदलाव करना है, उस पर क्लिक करें ताकि उसकी डिटेल्स खुल सकें।" },
        { id: 'btn-edit-record', type: ['click'], msg: " अब Salary Receipt में बदलाव करने के लिए Edit रिकॉर्ड बटन पर क्लिक करें।" },
        { id: 'edit-type', type: ['change'], msg: " आप वर्कर को सैलरी दे रहे हैं या एडवांस? यहाँ से बदलें, और Next Step बटन पर क्लिक करें।" },
        { id: 'edit-amount', type: ['keydown'], msg: () => {
            const typeEl = document.getElementById('edit-type');
            if (typeEl && typeEl.value === 'advance') { // 👇 यहाँ Advance की जगह advance (छोटे अक्षर) कर दिया है
                return " अगर आप एडवांस का Amount सही करना चाहते हैं, तो यहाँ सही Amount डालें, अगर एडवांस Amount पहले से सही है, तो Next Step बटन पर क्लिक करें।";
            }
            return " अगर आप सैलरी का Amount सही करना चाहते हैं, तो यहाँ सही Amount डालें, अगर Salary Amount पहले से सही है, तो Next Step बटन पर क्लिक करें।";
        }},
        { id: 'edit-recovery', type: ['keydown'], msg: " अगर आप एडवांस रिकवरी का Amount सही करना चाहते हैं, तो यहाँ सही Amount डालें। अगर रिकवरी अमाउंट पहले से सही है, तो Next Step बटन पर क्लिक करें।" },
        { id: 'edit-period', type: ['change'], msg: " आप Worker को Salary कैसे दे रहे हैं - हफ्ते के हिसाब से या महीने के हिसाब से? यहाँ से चुनें, और Next Step बटन पर क्लिक करें।" },
        { id: 'edit-mode', type: ['change'], msg: " क्या आपने Salary कैश में दे रहे हैं या Online? यहाँ से सही मोड चुनें, और Next Step बटन पर क्लिक करें।" },
        { id: 'edit-online-apps-box', type: ['click'], msg: " आपने ऑनलाइन चुना है, तो लिस्ट में से Payment ऐप Select करें PhonePe, GPay, Paytm, BharatPe या Other, चुनें और Next Step बटन पर क्लिक करें।" },
        { id: 'btn-update-record', type: ['click'], msg: " बहुत अच्छे! अब Update रिकॉर्ड बटन दबाकर इसे हमेशा के लिए सेव कर दें।" }
    ],

    // --- BADLI GUIDE FLOWS ---
    badli_search: [
        { id: 'open-search', type: ['click'], msg: " सबसे पहले Search Filters box पर क्लिक करें।" },
        { id: 'shift-filters', type: [], msg: " आपको किस Shift की बदली चेक करनी है? Day या  Night, क्लिक करें, या Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'select-absent-worker', type: ['change'], msg: " Filter Absent Worker में से जिस Worker ने बदली दी थी उस Worker को Select करें, या Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'select-badli-worker', type: ['change'], msg: " क्या आपको पता है कि किस Worker ने बदली ड्यूटी की थी? तो Filter बदली Worker से उस Worker को Select करो और अगर नहीं पता है तो Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-filter-date', type: ['change'], msg: " आखिर में डेट सेलेक्ट करनी है, अगर नहीं पता है तो डेट सेलेक्ट ना करें और  search Result देख सकते हो। " }
    ],

    // --- NEW WORKER GUIDE FLOWS (WITH PHOTO & errMsg) ---
    add_worker: [
        { id: 'btn-add-worker', type: ['click'], msg: " अपनी टेक्सटाइल कारखाने में नया वर्कर जोड़ने के लिए सबसे पहले ऊपर दिए गए Add बटन पर क्लिक करें।" },
        { id: 'btn-worker-photo-menu', type: ['click'], msg: " वर्कर का Profile Photo सेट करने के लिए इस Pencil (Edit) आइकन पर क्लिक करें।" },
        { id: 'btn-add-photo-text', type: ['click'], msg: " यहाँ वर्कर का Profile Photo सेट करने के लिए Add Photo button पर क्लिक करें, यह ऑप्शनल है, आप चाहें तो फोटो सेट करें या बिना फोटो लगाए सीधे Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'file-input-worker-photo', type: ['change', 'photoselected'], msg: " वर्कर का Profile Photo चुनें।" },
        { id: 'input-worker-name', type: ['keydown'], msg: " यहाँ नए वर्कर का पूरा नाम लिखें, यह ज़रूरी है, और Next Step बटन दबाएं。", errMsg: "यह फील्ड खाली है, पहले वर्कर का पूरा नाम लिखें।" },
        { id: 'input-worker-mobile', type: ['keydown'], msg: " वर्कर का 10 अंकों का मोबाइल नंबर दर्ज करें, यह ज़रूरी है, और Next Step बटन दबाएं。", errMsg: "यह फील्ड खाली है! पहले वर्कर का 10 अंकों का मोबाइल नंबर दर्ज करें।" },
        { id: 'input-worker-rate', type: ['keydown'], msg: " वर्कर को आप 1 मीटर कपड़ा बनाने के लिए कितने रुपये देना चाहते हैं, वो रेट यहाँ सेट करें, यह ज़रूरी है, और Next Step बटन दबाएं。", errMsg: "यह फील्ड खाली है! पहले वर्कर का रेट भरें।" },
        { id: 'input-worker-address', type: ['keydown'], msg: " वर्कर का पूरा Address दर्ज करें, यह ज़रूरी है, और Next Step बटन दबाएं。", errMsg: "यह फील्ड खाली है! पहले वर्कर का पूरा पता दर्ज करें।" },
        { id: 'select-worker-shift', type: ['change'], msg: " वर्कर की शिफ्ट चुनें (दिन या रात), यह ज़रूरी है, और Next Step बटन दबाएं。", errMsg: " पहले वर्कर की शिफ्ट चुनें (दिन या रात)।" },
        { id: 'input-worker-doj', type: ['change'], msg: " वर्कर के जॉइनिंग की तारीख (Date of Joining) चुनें, यह ज़रूरी है, और Next Step बटन दबाएं。", errMsg: " पहले वर्कर के जॉइनिंग की तारीख चुनें।" },
        { id: 'input-worker-shift-start', type: [], msg: " वर्कर की ड्यूटी शुरू होने का वक़्त (Start Time) चुनें, यह ज़रूरी है, और Next Step बटन दबाएं。", errMsg: " ड्यूटी शुरू होने का समय सेट करें।" },
        { id: 'input-worker-shift-end', type: [], msg: " वर्कर की ड्यूटी खत्म होने का वक़्त (End Time) चुनें, यह ज़रूरी है, और Next Step बटन दबाएं。", errMsg: " ड्यूटी खत्म होने का समय सेट करें।" },
        { id: 'container-worker-looms', type: [], msg: " वर्कर को ड्यूटी के लिए कौन-से नंबर के लूम देना चाहते हैं, उन्हें नीचे दी गई लिस्ट में से चुनें, और Next Step पर क्लिक करें।", errMsg: " ड्यूटी के लिए कम से कम एक लूम चुनें।" },
        
        // OPTIONAL FIELDS
        { id: 'input-worker-aadhaar', type: ['keydown'], msg: " यहाँ आधार नंबर डालें, यह ऑप्शनल है, आप चाहें तो इसे खाली छोड़कर Next Step बटन पर क्लिक करके आगे बढ़ सकते हैं।" },
        { id: 'input-worker-bank-name', type: ['keydown'], msg: " बैंक का नाम डालें, यह भी ऑप्शनल है, खाली छोड़कर Next Step बटन पर क्लिक करके आगे बढ़ सकते हैं।" },
        { id: 'input-worker-ifsc', type: ['keydown'], msg: " बैंक का IFSC कोड भरें, इसे भी खाली छोड़कर Next Step बटन पर क्लिक करके आगे बढ़ा जा सकता है।" },
        { id: 'input-worker-account', type: ['keydown'], msg: " अकाउंट नंबर दर्ज करें, यह ऑप्शनल है, भरना चाहें तो भरें या Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-worker-upi', type: ['keydown'], msg: " U P I आईडी डालें, यह आखिरी ऑप्शनल फील्ड है, चाहें तो भरें या खाली छोड़ दें।" },
        { id: 'btn-save-worker', type: ['click'], msg: " Good job! अब क्रिएट वर्कर प्रोफाइल बटन दबाकर इसे हमेशा के लिए सेव कर दें।" }
    ],
    
    // --- BADLI ASSIGNMENT FLOWS (WITH errMsg) ---
    set_badli: [
        { id: 'btn-badli', type: ['click'], msg: " बदली ड्यूटी लगाने के लिए सबसे पहले ऊपर बदली बटन पर क्लिक करें।" },
        { id: 'select-absent-worker', type: [], msg: " जो वर्कर आज छुट्टी पर है, लिस्ट में से उसका नाम चुनें, नाम अच्छे से सेलेक्ट करने के बाद ही Next Step बटन दबाएं।", errMsg: "यह फील्ड खाली है!  पहले लिस्ट में से उस वर्कर को चुनें जो आज छुट्टी पर है।" },
        { targetClass: 'guide-badli-input', type: [], msg: " अब उस वर्कर का नाम लिखें या चुनें जो छुट्टी वाले वर्कर की जगह आज ड्यूटी करेगा, इसके बाद Next Step दबाएं।", errMsg: "यह फील्ड खाली है!  पहले बदली वर्कर (Substitute) का नाम लिखें या लिस्ट से चुनें।" },
        
        { id: 'badli-date-section', type: [], msg: " अब आपको बदली की तारीख चुननी है। इस डिब्बे पर क्लिक करें और कैलेंडर में से वो तारीख चुनें जिस दिन से बदली शुरू होगी (Start Date), इसके बाद Next Step दबाएं।", errMsg: " बदली शुरू होने की तारीख (Start Date) चुनें।" },
        { id: 'badli-date-section', type: [], msg: " अब वो तारीख चुनें जिस दिन बदली खत्म होगी (End Date), अगर बदली सिर्फ एक ही दिन की है, तो उसी तारीख पर दोबारा क्लिक करें, इसके बाद Next Step दबाएं।", errMsg: " बदली खत्म होने की तारीख (End Date) चुनें।" },
        
        { id: 'input-badli-start-time', type: [], msg: " बदली ड्यूटी शुरू होने का वक़्त (Start Time) आराम से सेट करें, और फिर Next Step पर क्लिक करें।", errMsg: " बदली ड्यूटी शुरू होने का वक़्त (Start Time) सेट करें।" },
        { id: 'input-badli-end-time', type: [], msg: " अब बदली ड्यूटी खत्म होने का वक़्त (End Time) सेट करें, और फिर Next Step दबाएं।", errMsg: " बदली ड्यूटी खत्म होने का वक़्त (End Time) सेट करें।" },
        { targetClass: 'guide-badli-looms-step', type: ['loomsconfirmed'], msg:" सभी लूम पहले से चुने हुए हैं, जिन लूम पर बदली वर्कर ड्यूटी नहीं करेगा, उन्हें क्लिक करके हटाएँ और Next Step बटन पर क्लिक करके आगे बढ़ें।", errMsg: " Select All & Confirm बटन पर क्लिक करके लूम्स कन्फर्म करें।" },
        { id: 'btn-save-badli', type: ['click'], msg: " सब सेट होने के बाद कन्फर्म बदली पर क्लिक करें, आपकी बदली ड्यूटी लग चुकी है!" }
    ],

    // --- VACANCY GUIDE FLOWS ---
    add_vacancy: [
        { id: 'btn-post-job', type: ['click'], msg: " नया जॉब पोस्ट करने के लिए, सबसे पहले पोस्ट जॉब बटन पर क्लिक करें।" },
        { id: 'input-job-role', type: ['change'], msg: " आपको किस काम के लिए वर्कर चाहिए? लिस्ट में से जॉब रोल चुनें।" },
        { id: 'input-job-salary', type: ['keydown'], msg: " वर्कर को आप हफ्ते की कितनी Salary यानी पगार देंगे? वो यहाँ लिखें, और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-job-openings', type: ['keydown'], msg: " आपको कितने वर्कर्स की ज़रूरत है? यहाँ लिखें, और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-job-experience', type: ['keydown'], msg: " वर्कर को इस काम का कितने साल का Experience यानी अनुभव होना चाहिए? वो लिखें, और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-job-location', type: ['keydown'], msg: " अपना Address लोकेशन लिखें, ताकि वर्कर को पता चले कि काम की जगह कहाँ है, और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-job-mobile', type: ['keydown'], msg: " अपना मोबाइल नंबर डालें ताकि वर्कर सीधा आपको कॉल कर सके, और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'input-job-description', type: ['keydown'], msg: " जॉब के बारे में कोई और ज़रूरी जानकारी या नियम यहाँ लिखें, (जैसे: रहने की सुविधा है या नहीं), और Next Step बटन पर क्लिक करके आगे बढ़ें।" },
        { id: 'btn-save-job', type: ['click'], msg: " बहुत बढ़िया! अब पब्लिश जॉब पोस्ट बटन दबाकर इसे लाइव करें ताकि वर्कर्स इसे देख सकें, ध्यान दें: यह पोस्ट 7 दिन बाद अपने চরম डिलीट हो जाएगी।" }
    ]
};

const hindiWords = ["ज़ीरो", "एक", "दो", "तीन", "चार", "पांच", "छह", "सात", "आठ", "नौ", "दस", 
"ग्यारह", "बारह", "तेरह", "चौदह", "पंद्रह", "सोलह", "सत्रह", "अठारह", "उन्नीस", "बीस"];

// ये वो फील्ड्स और डिब्बे हैं जिन्हें बिना भरे 'आगे बढ़ें' किया जा सकता है
const OPTIONAL_FIELDS = [
    'file-input-worker-photo',
    'input-recovery', 'edit-recovery', 'input-exp-party', 'input-rev-party', 
    'shift-filters', 'input-filter-date', 
    'select-ot-mins', 'input-worker-aadhaar', 'input-worker-bank-name', 
    'input-worker-ifsc', 'input-worker-account', 'input-worker-upi',
    'input-badli-date', 'input-badli-start-time', 'input-badli-end-time', 
    'guide-badli-looms-step', 'badli-date-section', 'container-worker-looms',
    'btn-worker-photo-menu',
    'btn-salary-monthly', 'salary-period-box', 'mode-selection-box',
    'select-report-worker', 'input-report-from', 'input-report-to',
    'edit-type', 'edit-date', 'edit-mode', 'edit-period', 'edit-online-apps-box',
    'select-mode', 'online-apps-box', 'input-prod-meters', 'input-rate',
    'input-yarn-date', 'select-yarn-material', 'select-yarn-type',
    'ledger-receivables', 'ledger-payables',
    'select-absent-worker', 'select-badli-worker', 'guide-ot-trigger',
];

export const useSmartGuide = (onStartGuideReset) => {
    const [voiceAssist, setVoiceAssist] = useState(false);
    const [showGuideModal, setShowGuideModal] = useState(false);
    const [pendingConfirm, setPendingConfirm] = useState(null);
    const [activeGuideFlow, setActiveGuideFlow] = useState(null);
    const [currentStepIndex, setCurrentStepIndex] = useState(0);

    const voiceLoopRef = useRef(null);
    const targetElementRef = useRef(null);
    const lastAdvanceTime = useRef(0); // डबल क्लिक/रेस कंडीशन रोकने के लिए

    function getHindiNumberText(num) {
        num = parseInt(num);
        if (isNaN(num)) return "";
        if (num === 0) return "जीरो";
        if (num < 100 && hindiWords[num]) return hindiWords[num];
        return num.toString();
    }

    const getStepMsg = (step) => {
        if (!step) return "";
        const m = step.msg || step.message;
        return typeof m === 'function' ? m() : m;
    };

    const speakHinglish = (msg) => {
        if (!window.speechSynthesis) return;
        
        // 1. पुरानी आवाज़ तुरंत बंद करें
        window.speechSynthesis.cancel();
        
        // बारीक नियम: शब्दों का सुधार और .0 को हटाना, HOUR/MINUTE और पॉइंट को सही पढ़ना
        let processedMsg = msg
            .replace(/Rs\./ig, ' रुपये')
            .replace(/kg/ig, ' किलो')
            .replace(/\btab\b/ig, ' टॅब')
            .replace(/\bm\b/ig, ' मीटर')
            .replace(/\bmar\b/ig, ' March')
            .replace(/\bnht\b/ig, ' NIGHT')
            .replace(/HOUR/ig, ' घंटा')      
            .replace(/MINUTE/ig, ' मिनट')    
            .replace(/\.0+(?!\d)/g, '') 
            .replace(/(\d)\.(\d)/g, '$1 पॉइंट $2'); 

        processedMsg = processedMsg.replace(/\d+/g, (match) => getHindiNumberText(match));

        const utterance = new SpeechSynthesisUtterance(processedMsg);
        utterance.lang = 'hi-IN'; 
        
        // 👇 100x Real Voice Control Setup यहाँ डाला गया है 👇
        const savedSpeed = parseFloat(localStorage.getItem('voiceSpeed')) || 1.0;
        const savedVoiceURI = localStorage.getItem('selectedVoiceURI');

        utterance.rate = savedSpeed; // (पहले यहाँ 0.9 फिक्स था, अब आपके स्लाइडर से कंट्रोल होगा)
        
        if (savedVoiceURI) {
            const voices = window.speechSynthesis.getVoices();
            const selected = voices.find(v => v.voiceURI === savedVoiceURI);
            if (selected) utterance.voice = selected;
        }
        // 👆 100x Real Voice Setup यहाँ खत्म 👆
        
        // 2. Android Bug Fix: 50ms का छोटा ब्रेक देकर नई आवाज़ चलाएं ताकि वो पुरानी से मिक्स ना हो
        setTimeout(() => {
            window.speechSynthesis.speak(utterance);
        }, 50);
    };

    const handleVoiceClick = (e, msg, originalAction, actionId = null, isAlreadyOpen = false, alreadyOpenMsg = null) => {
        if (e && e.stopPropagation) e.stopPropagation();
        if (e && e.preventDefault && originalAction) e.preventDefault();

        // 👇 किसी भी बटन/सेक्शन पर क्लिक करते ही पुरानी आवाज़ को तुरंत रोक दें
        if (window.speechSynthesis) {
            window.speechSynthesis.cancel();
        }

        if (activeGuideFlow) {
            if (originalAction) originalAction(e);
            return;
        }

        if (voiceAssist) {
            if (isAlreadyOpen) { 
                speakHinglish(alreadyOpenMsg || " आप पहले से ही इस सेक्शन में मौजूद हैं."); 
                return; 
            }
            if (actionId && originalAction) {
                if (pendingConfirm === actionId) {
                    setPendingConfirm(null); originalAction(e);
                } else {
                    setPendingConfirm(actionId);
                    let confirmMsg = msg;
                    
                    // --- VACANCIES MESSAGES ---
                    if (actionId === 'btn-post-job') {
                        confirmMsg += " क्या आप अपने Textile कारखाने में नए वर्कर्स के लिए वेकेंसी डालना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'tab-my-jobs') {
                        confirmMsg += " क्या आप अपनी डाली हुई जॉब्स देखना चाहते हैं, तो इस Button पर दोबारा क्लिक करें।";
                    } else if (actionId === 'tab-all-jobs') {
                        confirmMsg += " क्या आप अपनी डाली हुई जॉब्स और दूसरे टेक्सटाइल कारखानों की जॉब्स देखना चाहते हैं, तो इस Button पर दोबारा क्लिक करें।";
                    } else if (actionId.includes('btn-edit-') && actionId !== 'btn-edit-worker' && actionId !== 'btn-edit-record') {
                        confirmMsg += " क्या आप इस जॉब पोस्ट को एडिट करना चाहते हैं, तो दोबारा क्लिक करें।";                    } else if (actionId.includes('btn-delete-')) {
                        confirmMsg += " क्या आप इस जॉब पोस्ट को हमेशा के लिए डिलीट करना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId.includes('btn-toggle-status-')) {
                        confirmMsg += " क्या आप इस जॉब का स्टेटस बदलना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId.includes('cat-')) {
                        confirmMsg += " क्या आप इस केटेगरी की जॉब्स फिल्टर करना चाहते हैं, तो इस फ़िल्टर पर दोबारा क्लिक करें।";
                    } else if (actionId.includes('btn-call-')) {
                        confirmMsg += " क्या आप इस कारखाने के मालिक को कॉल लगाना चाहते हैं, तो इस कॉल बटन पर दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-close-form' || actionId === 'btn-close-guide') {
                        confirmMsg += " क्या आप इसे बंद करना चाहते हैं, तो इस क्लोज़ बटन पर दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-cancel-delete') {
                        confirmMsg += " क्या आप डिलीट कैंसल करना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-confirm-delete') {
                        confirmMsg += " क्या आप कन्फर्म करके इसे हमेशा के लिए डिलीट करना चाहते हैं, तो इस डिलीट बटन पर दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-guide-menu') {
                        confirmMsg += " क्या आप स्मार्ट गाइड का मेनू खोलना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'guide-add-vacancy') {
                        confirmMsg += " क्या आप नया जॉब पोस्ट करने का ट्यूटोरियल शुरू करना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-save-job') {
                        confirmMsg += " क्या आप इस जॉब को लाइव पब्लिश करना चाहते हैं, तो दोबारा क्लिक करें।";
                    }
                    
                    // --- WORKERS MESSAGES ---
                    else if (actionId.includes('view-expense-history') || actionId.includes('view-revenue-history')) {
                        confirmMsg += " क्या आप इसकी हिस्ट्री देखना चाहते हो, तो दोबारा इस बॉक्स पर क्लिक करो।";
                    } else if (actionId.includes('view-history-')) {
                        const workerName = actionId.split('||')[1] || "वर्कर";
                        confirmMsg += ` क्या आप ${workerName} की प्रोडक्शन हिस्ट्री देखना चाहते हैं, तो यहाँ दोबारा क्लिक करें।`;
                    } else if (actionId.includes('menu-edit-')) {
                        const workerName = actionId.split('||')[1] || "वर्कर";
                        confirmMsg += ` क्या आप इस ${workerName} की प्रोफाइल एडिट करना चाहते हैं, तो दोबारा क्लिक करें।`;
                    } else if (actionId.includes('menu-set-ot-')) {
                        const workerName = actionId.split('||')[1] || "वर्कर";
                        confirmMsg += ` क्या आप इस ${workerName} को ओवरटाइम ड्यूटी पर लगाना चाहते हो, तो दोबारा क्लिक करें।`;
                    } else if (actionId.includes('toggle-looms-')) {
                        const workerName = actionId.split('||')[1] || "वर्कर";
                        confirmMsg += ` क्या आप इस ${workerName} का प्रोडक्शन लूम वाइज़ देखना चाहते हैं, किस लूम पर कितना प्रोडक्शन हुआ है, तो दोबारा क्लिक करें।`;
                    } else if (actionId === 'btn-add-worker') {
                        confirmMsg += " क्या आप अपने टेक्सटाइल कारखाने में नया वर्कर जोड़ना चाहते हो तो दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-badli') {
                        confirmMsg += " क्या आप बदली ड्यूटी लगाना चाहते हो तो दोबारा क्लिक करें।";
                    } 

                    // --- APP.JS & DASHBOARD MESSAGES ---
                    else if (actionId === 'tab-login-owner') {
                        confirmMsg += " क्या आप ओनर अकाउंट से लॉग इन करना चाहते हैं, तो इस टैब पर दोबारा क्लिक करें।";
                    } else if (actionId === 'tab-login-worker') {
                        confirmMsg += " क्या आप वर्कर अकाउंट से लॉग इन करना चाहते हैं, तो इस टैब पर दोबारा क्लिक करें।";
                    } else if (actionId === 'toggle-notif') {
                        confirmMsg += " क्या आप नोटिफिकेशन चालू या बंद करना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId && actionId.startsWith('btn-wallpaper')) {
                        confirmMsg += " क्या आप ऐप का बैकग्राउंड वॉलपेपर बदलना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId && actionId.startsWith('tab-search-')) {
                        confirmMsg += " क्या आप इस तरीके से सर्च करना चाहते हैं, तो इस टैब पर दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-do-search') {
                        confirmMsg += " क्या आप रिकॉर्ड सर्च करना चाहते हैं, तो इस सर्च बटन पर दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-view-detailed-search' || actionId === 'btn-view-stats-detail') {
                        confirmMsg += " क्या आप इसकी पूरी डिटेल रिपोर्ट देखना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-edit-profile') {
                        confirmMsg += " क्या आप अपनी प्रोफाइल की जानकारी बदलना चाहते हैं, तो इस एडिट बटन पर दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-cancel-edit') {
                        confirmMsg += " क्या आप प्रोफाइल एडिट कैंसल करना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-save-profile') {
                        confirmMsg += " क्या आप नई जानकारी सेव करना चाहते हैं, तो इस सेव बटन पर दोबारा क्लिक करें।";
                    } else if (actionId === 'menu-profile-personal') {
                        confirmMsg += " क्या आप अपनी पर्सनल डिटेल्स देखना या बदलना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'menu-profile-bank') {
                        confirmMsg += " क्या आप बैंक और टेक्सटाइल कारखाने की डिटेल्स देखना या बदलना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'menu-profile-shift') {
                        confirmMsg += " क्या आप दिन और रात की शिफ्ट का टाइम सेट करना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId && actionId.startsWith('menu-support-')) {
                        confirmMsg += " क्या आप मुकादम प्रो के सपोर्ट से संपर्क करना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-logout') {
                        confirmMsg += " लॉग आउट का मतलब है कि आप अपने अकाउंट से बाहर निकल जाएँगे और डैशबोर्ड नहीं देख पाएंगे, क्या आप वाकई ऐप से बाहर निकलना चाहते हैं, तो दोबारा क्लिक करें।";
                    
                    } else if (actionId === 'btn-search' || actionId === 'btn-nav-search') {
                        confirmMsg += " इस सर्च बटन में जाने के लिए दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-settings' || actionId === 'btn-nav-settings') {
                        confirmMsg += " इस सेटिंग्स बटन में जाने के लिए दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-profile' || actionId === 'btn-nav-profile') {
                        confirmMsg += " इस प्रोफाइल बटन में जाने के लिए दोबारा क्लिक करें।";

                    } else if (actionId === 'tab-stats-week') {
                        confirmMsg += " क्या आप इस हफ्ते का प्रोडक्शन देखना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'tab-stats-month') {
                        confirmMsg += " क्या आप इस महीने का प्रोडक्शन देखना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'tab-stats-total') {
                        confirmMsg += " क्या आप टोटल प्रोडक्शन देखना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId && actionId.startsWith('tab-dash-') || actionId && actionId.startsWith('tab-loom-filter-')) {
                        confirmMsg += " क्या आप यह फ़िल्टर लगाना चाहते हैं, तो दोबारा क्लिक करें।";
                    
                    } else if (actionId === 'btn-detailed-report') {
                        confirmMsg += " क्या आप पूरे कारखाने की डिटेल प्रोडक्शन रिपोर्ट देखना चाहते हैं, तो दोबारा क्लिक करें।";                   
                    } else if (actionId === 'nav-home') {
                        confirmMsg += " क्या आप होम डैशबोर्ड page पर जाना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'nav-workers') {
                        confirmMsg += " क्या आप वर्कर्स पेज पर जाना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'nav-badli') {
                        confirmMsg += " क्या आप बदली Log का रिकॉर्ड देखना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'nav-payments') {
                        confirmMsg += " क्या आप payments page पर जाना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'nav-stock') {
                        confirmMsg += " क्या आप स्टॉक पेज पर जाना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'nav-jobs') {
                        confirmMsg += " क्या आप जॉब्स पेज पर जाना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-close-settings' || actionId === 'btn-close-search' || (actionId && actionId.includes('btn-back'))) {
                        confirmMsg += " क्या आप पीछे जाना चाहते हैं, तो दोबारा क्लिक करें।";
                    
                        } else if (actionId === 'btn-detailed-report-week') {
                        confirmMsg += " क्या आप इस हफ्ते के प्रोडक्शन की पूरी डिटेल रिपोर्ट देखना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-detailed-report-month') {
                        confirmMsg += " क्या आप इस महीने के प्रोडक्शन की पूरी डिटेल रिपोर्ट देखना चाहते हैं, तो दोबारा क्लिक करें।";
                    } else if (actionId === 'btn-detailed-report-total') {
                        confirmMsg += " क्या आप टोटल प्रोडक्शन की पूरी डिटेल रिपोर्ट देखना चाहते हैं, तो दोबारा क्लिक करें।";
                    
                    }   else if (actionId === 'btn-history-menu') {
                        confirmMsg += " क्या आप वर्कर की डिटेल्स एडिट करना चाहते हैं या प्रोडक्शन हिस्ट्री रिपोर्ट डाउनलोड करना चाहते हैं, तो दोबारा क्लिक करें।";
                    
                        }   else if (actionId === 'btn-edit-worker') {
                        confirmMsg += " क्या आप वर्कर की डिटेल्स एडिट करना चाहते हैं, तो दोबारा क्लिक करें।";
                     }   else if (actionId === 'btn-download-pdf') {
                        confirmMsg += " क्या आप पीडीएफ रिपोर्ट डाउनलोड करना चाहते हैं, तो दोबारा क्लिक करें।";
                    
                      } else if (actionId === 'open-search') {
    confirmMsg += " बदली प्रोडक्शन सर्च करने के लिए दोबारा क्लिक करें।";

                    }   else if (actionId === 'btn-search-expand') {
                        confirmMsg = msg; 
                     }   else if (actionId === 'tab-weekly') {
                        confirmMsg += " क्या आप हफ्ते के हिसाब से प्रोडक्शन हिस्ट्री देखना चाहते हैं, तो दोबारा क्लिक करें।";
                     }   else if (actionId === 'tab-monthly') {
                        confirmMsg += " क्या आप महीने के हिसाब से प्रोडक्शन हिस्ट्री देखना चाहते हैं, तो दोबारा क्लिक करें।";
                     }   else if (actionId && actionId.startsWith('tab-year-')) {
                        const clickedYear = actionId.replace('tab-year-', '');
                        confirmMsg += ` क्या आप साल ${clickedYear} का प्रोडक्शन रिकॉर्ड देखना चाहते हैं, तो दोबारा क्लिक करें।`;
                     }   else if (actionId && actionId.startsWith('expand-')) {
                        // expand वाले बॉक्स के लिए कोई डिफ़ॉल्ट मैसेज नहीं
                     }   
                     // --- HELP & SUPPORT MESSAGES ---
                     else if (actionId === 'help-whatsapp') {
                         confirmMsg += " क्या आप सहायता के लिए हमारे व्हाट्सएप सपोर्ट से जुड़ना चाहते हैं, तो दोबारा क्लिक करें।";
                     } else if (actionId === 'help-call') {
                         confirmMsg += " क्या आप अपनी समस्या के समाधान के लिए हमारी मुकादम प्रो की एक्सपर्ट टीम को कॉल लगाना चाहते हैं, तो दोबारा क्लिक करें।";
                     } else if (actionId === 'help-email') {
                         confirmMsg += " क्या आप हमें अपनी समस्या ईमेल के ज़रिए भेजना चाहते हैं, तो दोबारा क्लिक करें।";
                     } else {
                        // डायनामिक और कस्टम एक्शन्स के लिए (Generic 'kya aap isme jana chahte hain' removed)
                        if (msg) {
                            confirmMsg = msg;
                            // अगर पेजेज से आ रहे कस्टम मैसेज में 'दोबारा क्लिक' नहीं लिखा है, तो सिर्फ उसे जोड़े
                            if (!confirmMsg.includes("दोबारा क्लिक")) {
                                confirmMsg += " देखने के लिए दोबारा क्लिक करें।";
                            }
                        } else {
                            confirmMsg = " इसे खोलने के लिए दोबारा क्लिक करें।";
                        }
                    }

                    speakHinglish(confirmMsg);
                }
            } else {
                if (msg) speakHinglish(msg);
                if (originalAction) originalAction(e);
            }
        } else {
            if (originalAction) originalAction(e);
        }
    };

    const toggleVoiceAssist = () => {
        const newState = !voiceAssist;
        setVoiceAssist(newState);
        setPendingConfirm(null);
        if (newState) {
            speakHinglish(" Voice Guide On हो गया है, अब आप स्क्रीन पर जहाँ भी क्लिक करेंगे, आपको उसकी जानकारी दी जाएगी।");
        } else {
            window.speechSynthesis.cancel();
        }
    };

    const handleFocusVoice = (msg) => { if(voiceAssist && msg && !activeGuideFlow) speakHinglish(msg); };
    const handleSelectVoice = (val, fieldName) => { if(voiceAssist && val && !activeGuideFlow) speakHinglish(`Aapne ${fieldName} mein ${val} chuna hai.`); };
    const handleTextBlurVoice = (val, fieldName) => { if(voiceAssist && val && !activeGuideFlow) speakHinglish(`Aapne ${fieldName} mein ${val} fill kiya hai.`); };
    
    // --- AUTO ERROR ANNOUNCEMENT (Global Alert Override) ---
    useEffect(() => {
        const originalAlert = window.alert;
        
        window.alert = function(message) {
            // 1. अगर Voice Guide ON है, तो एरर मैसेज अपने आप बोलेंगे
            if (voiceAssist && window.speechSynthesis) {
                window.speechSynthesis.cancel(); // पुरानी आवाज़ तुरंत बंद करें
                
                let processedMsg = String(message)
                    .replace(/Rs\./ig, 'रुपये')
                    .replace(/kg/ig, 'किलो')
                    .replace(/!/g, '') // एक्सक्लेमेशन मार्क हटाएं ताकि आवाज़ स्मूथ रहे
                    .replace(/\n/g, ' '); // लाइन ब्रेक को स्पेस में बदलें
                
                const utterance = new SpeechSynthesisUtterance(processedMsg);
                utterance.lang = 'hi-IN';
                utterance.rate = 0.9;
                
                // एरर मैसेज तुरंत प्ले करें
                window.speechSynthesis.speak(utterance);
                
                // 2. Alert पॉपअप को थोड़ा (100ms) रोक कर दिखाएं ताकि मोबाइल में आवाज़ ब्लॉक ना हो
                setTimeout(() => {
                    originalAlert(message);
                }, 100);
            } else {
                // अगर वॉइस गाइड OFF है तो नार्मल Alert दिखाएं
                originalAlert(message);
            }
        };

        // जब कंपोनेंट हटेगा तो वापस ओरिजिनल Alert सेट कर देंगे (Cleanup)
        return () => {
            window.alert = originalAlert;
        };
    }, [voiceAssist]); 

    const startSmartGuide = (flowName) => {
        setShowGuideModal(false);
        // onStartGuideReset वाली लाइन हटा दी गई है ताकि पेज चेंज ना हो
        setActiveGuideFlow(flowName);
        setCurrentStepIndex(0);
    };

    const cleanupGuideStep = () => {
        clearInterval(voiceLoopRef.current);
        if (targetElementRef.current) {
            const els = Array.isArray(targetElementRef.current) ? targetElementRef.current : [targetElementRef.current];
            els.forEach(el => { if (el && el.classList) el.classList.remove('smart-guide-target'); });
            targetElementRef.current = null;
        }
        
        // 👇 एनीमेशन वाले ड्रापडाउन को गायब करने का कोड
        const fakeDrop = document.getElementById('fake-dropdown-guide');
        if (fakeDrop) fakeDrop.remove();
    };

    const endSmartGuide = (isCanceled = false) => {
        cleanupGuideStep(); setActiveGuideFlow(null); setCurrentStepIndex(0);
        if (window.speechSynthesis) {
            window.speechSynthesis.cancel(); 
        }
        if (!isCanceled) {
        speakHinglish(isCanceled ? " Smart Live Guide बंद कर दिया गया है." : " Live Guide Complete हो गया है. आपका शुक्रिया!");
        }
    };

    const advanceNextStep = (isManualClick = false) => {
        const now = Date.now();
        if (now - lastAdvanceTime.current < 400) return false;

        if (!activeGuideFlow) return false;
        const flow = GUIDE_FLOWS[activeGuideFlow];
        if (!flow || currentStepIndex >= flow.length) return false;

        const step = flow[currentStepIndex];
        let canAdvance = true;
        
        let errorMessage = step.errMsg || " पहले इस फील्ड को सही से भरें।";

        let els = [];
        if (step.targetClass) els = Array.from(document.querySelectorAll('.' + step.targetClass));
        else if (step.id) { const el = document.getElementById(step.id); if(el) els.push(el); }
        else if (step.targetId) { const el = document.getElementById(step.targetId); if(el) els.push(el); }

        const isOptional = OPTIONAL_FIELDS.includes(step.id) || OPTIONAL_FIELDS.includes(step.targetClass) || OPTIONAL_FIELDS.includes(step.targetId);

        if (els.length > 0) {
            let inputsToCheck = [];
            els.forEach(el => {
                if (['INPUT', 'SELECT', 'TEXTAREA'].includes(el.tagName)) {
                    inputsToCheck.push(el);
                }
                const innerInputs = el.querySelectorAll('input, select, textarea');
                innerInputs.forEach(inner => inputsToCheck.push(inner));
            });

            if (inputsToCheck.length > 0) {
                let isFilled = inputsToCheck.some(el => {
                    if (el.tagName === 'INPUT' && (el.type === 'checkbox' || el.type === 'radio')) return el.checked;
                    return el.value !== undefined && el.value !== null && String(el.value).trim() !== '';
                });

                if (!isOptional && !isFilled) {
                    canAdvance = false;
                    errorMessage = step.errMsg || " यह फील्ड खाली है, इसे सही से भरें, उसके बाद ही Next Step बटन पर क्लिक करके आगे बढ़ें।";
                }
            } else {
                if (!isOptional && isManualClick) {
                    canAdvance = false;
                    errorMessage = " shortcut का इस्तेमाल ना करें, Highlight किए गए Option पर ही क्लिक करें।";
                }
            }
        }

        if (!canAdvance) {
            speakHinglish(errorMessage);
            
            if (voiceLoopRef.current) {
                clearInterval(voiceLoopRef.current);
                const stepMsg = getStepMsg(step);
                voiceLoopRef.current = setInterval(() => { speakHinglish(stepMsg); }, 25000); 
            }

            els.forEach(el => {
                if (el) {
                    const originalShadow = el.style.boxShadow;
                    el.style.boxShadow = '0 0 0 4px #DC2626, 0 0 20px #DC2626';
                    setTimeout(() => { if (el) el.style.boxShadow = originalShadow; }, 1500);
                }
            });
            return false;
        }

        lastAdvanceTime.current = Date.now();
        setCurrentStepIndex(prev => prev + 1);
        return true;
    };

    useEffect(() => {
        if (!activeGuideFlow) return;

        const handleGlobalClick = (e) => {
            if (e.target.closest('#btn-stop-guide') || e.target.closest('#btn-next-step')) return;
            
            // 👇 यहाँ flow डिफाइन किया गया है ताकि कोई एरर ना आए
            const flow = GUIDE_FLOWS[activeGuideFlow];
            const step = flow ? flow[currentStepIndex] : null;

            if (targetElementRef.current) {
                const els = Array.isArray(targetElementRef.current) ? targetElementRef.current : [targetElementRef.current];
                
                // अगर हाईलाइट किए हुए डिब्बे के अंदर क्लिक हुआ है
                if (els.some(el => el.contains(e.target))) {
                    
                    // 👇 जादू 1: अगर Shift वाले डिब्बे में (Day/Night) क्लिक हुआ है, तो 0.3 सेकंड बाद Auto-Next हो जाएगा!
                    if (step && step.id === 'shift-filters') {
                        setTimeout(() => {
                            const nextBtn = document.getElementById('btn-next-step');
                            if (nextBtn) nextBtn.click();
                        }, 300); 
                    }
                    return; 
                }
            }
            
            // 👇 जादू 2: Smart Jump - अगर यूज़र ने सीधे अगले स्टेप पर क्लिक किया, तो गाइड खुद आगे बढ़ जाएगा
            const nextStep = flow ? flow[currentStepIndex + 1] : null;
            if (nextStep) {
                let nextEls = [];
                if (nextStep.targetClass) nextEls = Array.from(document.querySelectorAll('.' + nextStep.targetClass));
                else if (nextStep.id) { const el = document.getElementById(nextStep.id); if (el) nextEls.push(el); }
                else if (nextStep.targetId) { const el = document.getElementById(nextStep.targetId); if (el) nextEls.push(el); }
                
                if (nextEls.some(el => el.contains(e.target))) {
                    const success = advanceNextStep(false);
                    if (!success) { e.preventDefault(); e.stopPropagation(); }
                    return; 
                }
            }
            
            e.preventDefault();
            e.stopPropagation();
            
            if (!step) return;

            const isOptional = OPTIONAL_FIELDS.includes(step.id) || OPTIONAL_FIELDS.includes(step.targetClass) || OPTIONAL_FIELDS.includes(step.targetId);

            if (isOptional) {
                speakHinglish(" कृपया पहले हाईलाइट कि गई फील्ड भरे या Next Step बटन दबाएं।");
            } else {
                speakHinglish(step.errMsg || " पहले हाईलाइट कि गई फील्ड भरे और Next Step बटन पर क्लिक करें।");
                
                if (voiceLoopRef.current) {
                    clearInterval(voiceLoopRef.current);
                    const stepMsg = getStepMsg(step);
                    voiceLoopRef.current = setInterval(() => { speakHinglish(stepMsg); }, 12000);
                }

                if (targetElementRef.current) {
                    const els = Array.isArray(targetElementRef.current) ? targetElementRef.current : [targetElementRef.current];
                    els.forEach(el => {
                        if (el) {
                            const originalShadow = el.style.boxShadow;
                            el.style.boxShadow = '0 0 0 4px #DC2626, 0 0 20px #DC2626';
                            setTimeout(() => { if (el) el.style.boxShadow = originalShadow; }, 1500);
                        }
                    });
                }
            }
        };
        
        document.addEventListener('click', handleGlobalClick, true);
        return () => { document.removeEventListener('click', handleGlobalClick, true); };
    }, [activeGuideFlow, currentStepIndex]);

    useEffect(() => {
        if (!activeGuideFlow) return;
        const flow = GUIDE_FLOWS[activeGuideFlow];
        if (!flow || currentStepIndex >= flow.length) { endSmartGuide(false); return; }

        const step = flow[currentStepIndex];
        let retryCount = 0;
        let handler;

        const findAndHighlight = () => {
            let els = [];
            if (step.targetClass) els = Array.from(document.querySelectorAll('.' + step.targetClass));
            else if (step.id) { const el = document.getElementById(step.id); if (el) els.push(el); }
            else if (step.targetId) { const el = document.getElementById(step.targetId); if (el) els.push(el); }

            if (els.length > 0) {
                cleanupGuideStep();
                targetElementRef.current = els;
                els.forEach(el => el.classList.add('smart-guide-target'));
                
                const stepMsg = getStepMsg(step);
                speakHinglish(stepMsg);
                voiceLoopRef.current = setInterval(() => { speakHinglish(stepMsg); }, 12000); 

               handler = (e) => {
                    if (e.type === 'keydown' && e.key !== 'Enter') return; 
                    if (e.type === 'keydown') e.preventDefault(); 

                    setTimeout(() => {
                        const success = advanceNextStep(false); 
                        if (success) {
                            const eventTypes = Array.isArray(step.type) ? step.type : (step.type ? [step.type] : ['click']);
                            els.forEach(el => eventTypes.forEach(t => el.removeEventListener(t, handler)));
                        }
                    }, 200); 
                };
                
                const eventTypes = Array.isArray(step.type) ? step.type : (step.type ? [step.type] : ['click']);
                els.forEach(el => eventTypes.forEach(t => el.addEventListener(t, handler)));

            } else {
                const isOptional = OPTIONAL_FIELDS.includes(step.id) || OPTIONAL_FIELDS.includes(step.targetClass) || OPTIONAL_FIELDS.includes(step.targetId);
                
                if (isOptional) {
                    // 👇 FIX: अब गाइड 'Optional' फील्ड्स के लिए भी थोड़ा इंतज़ार करेगा, ताकि एनीमेशन पूरा हो सके
                    if (retryCount < 6) { 
                        retryCount++; 
                        setTimeout(findAndHighlight, 500); 
                    } else { 
                        setCurrentStepIndex(prev => prev + 1); 
                    }
                } else {
                    if (retryCount < 40) { 
                        retryCount++; 
                        setTimeout(findAndHighlight, 500); 
                    } else { 
                        endSmartGuide(true);}
                }
            }
        };

        findAndHighlight();

        return () => {
            cleanupGuideStep();
            if (targetElementRef.current && handler) {
                const els = Array.isArray(targetElementRef.current) ? targetElementRef.current : [targetElementRef.current];
                const eventTypes = Array.isArray(step.type) ? step.type : (step.type ? [step.type] : ['click']);
                els.forEach(el => eventTypes.forEach(t => el.removeEventListener(t, handler)));
            }
        };
    }, [activeGuideFlow, currentStepIndex]);

    const currentGuideMessage = activeGuideFlow && GUIDE_FLOWS[activeGuideFlow] 
                                ? getStepMsg(GUIDE_FLOWS[activeGuideFlow][currentStepIndex])
                                : "";

    return {
        voiceAssist, setVoiceAssist, showGuideModal, setShowGuideModal,
        activeGuideFlow, currentGuideMessage, toggleVoiceAssist, handleVoiceClick,
        handleFocusVoice, handleSelectVoice, handleTextBlurVoice,
        startSmartGuide, endSmartGuide, advanceNextStep, speakHinglish, setPendingConfirm
    };
};

export default useSmartGuide;